// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6209) return "static/chunks/ui-050e0df2cd986524.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6921 ? "aliyun-oss" : chunkId) + "." + {"230":"67c301b10868d317","233":"9e328b33cf8eed63","3293":"02cefbfd65bbcc49","3428":"e32a9c0179e763e2","5585":"fc9d03df3df4658a","6921":"9c3adf32bb13106f","6951":"c269161b381f1ecd","7483":"a658751469e46b1e","7796":"17204318f997faee","8329":"88bce3ffaea99bc8"}[chunkId] + ".js";
};